/**
 * Adapptio Icon Pack - Material Design Icons
 *
 * @package ext-integrations-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IAppClient } from "@adapptio/lib-core";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const registerExtension = (application: IAppClient): void => {
	// Icons are registered only server-side
};